const ymapsPromise: { [key: string]: Promise<YMaps.IYMaps> } = {};

const SCRIPT_URL = 'https://enterprise.api-maps.yandex.ru/2.1/';

export async function loadYMapsApi(apiKey: string, modules?: string[]): Promise<YMaps.IYMaps> {
  if (!ymapsPromise[apiKey]) {
    ymapsPromise[apiKey] = new Promise((resolve, reject) => {
      if (window.ymaps) {
        resolve(window.ymaps);

        return;
      }

      const e = window.document.createElement('script');
      e.src = `${SCRIPT_URL}?${[
        `apikey=${encodeURIComponent(apiKey)}`,
        'lang=ru-RU',
        'load=package.system',
        'coordorder=longlat',
      ].join('&')}`;
      e.async = true;
      e.defer = true;
      e.onload = () => {
        resolve(window.ymaps);
      };
      e.onerror = () => {
        reject(new Error('Unable to load Yandex Maps API'));
      };
      window.document.body.appendChild(e);
    });
  }

  return ymapsPromise[apiKey].then(
    ymaps =>
      new Promise<YMaps.IYMaps>((resolve, reject) => {
        ymaps.ready({
          require: modules,
          successCallback: () => {
            resolve(ymaps);
          },
          errorCallback: error => {
            reject(error);
          },
        });
      }),
  );
}
